import {
  ArrowLeftOutlined,
  DeleteOutlined,
  GiftOutlined,
  HeartOutlined,
  MinusOutlined,
  PlusOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
  ShareAltOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { message } from "antd";
import axios from "axios";
import config from "../../configuration/config";
import { Button, Card, Col, Empty, Image, InputNumber, Progress, Row, Space, Tag, Tooltip, Typography } from "antd";
import { list, quantity } from "cart-localstorage";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import { Price } from "../../components/__simple/_price";
import { useUserCart } from "../../User/hooks/useUserCart";
import ConfirmContext from "../../utils/confirmContext";
import { getData } from "../../utils/localStorageManager";
import Breadcrumb from "../../components/__simple/breadcrumb";
const { Title, Text } = Typography;

// ألوان الموقع المحدثة مع تدرجات إضافية
const colors = {
  primary: "#00b362",
  primaryLight: "#00b362",
  primaryDark: "#00b362",
  primaryGradient: "#00b362",
  primaryGradientOpacity: "#00b362",
  secondary: "#1a1a1a",
  secondaryLight: "#2d2d2d",
  accent: "#ff6b35",
  white: "#ffffff",
  grayLighter: "#f8f9fa",
  grayLight: "#e9ecef",
  gray: "#979595",
  grayDark: "#707070",
  black: "#000000",
  success: "#00b362",
  warning: "#ffc107",
  danger: "#d62828",
  info: "#2c80ff",
};

// نظام أحجام الخطوط بناءً على الملف المرفق
const textSizes = {
  10: "1rem",
  11: "1.1rem",
  12: "1.2rem",
  13: "1.3rem",
  14: "1.4rem",
  15: "1.5rem",
  16: "1.6rem",
  17: "1.7rem",
  18: "1.8rem",
  19: "1.9rem",
  20: "2.1rem",
  24: "2.5rem",
  30: "3.1rem",
  40: "4.1rem",
  50: "5.1rem",
};

const PremiumCartPage = () => {
  const { t: trans, i18n } = useTranslation(["info", "cartFile", "new"]);
  let lang = i18n.language || "ar";
  const [items, setItems] = useState([]); // جلب العناصر من التخزين المحلي
  const [savedItems, setSavedItems] = useState([]);
  const location = useLocation();
  const thisConfirmContext = useContext(ConfirmContext);
  const [showSavedItems, setShowSavedItems] = useState(false);
  const history = useHistory();
  const [partErrors, setPartErrors] = useState([]);
  const { removecartItems, removePulkcartItems, changecartItem } = useUserCart();
  function getCartList() {
    // الأنواع التي تريد فلترتها
    const types = ["part"];
    const lowerTypes = types.map((t) => t.toLowerCase());

    // جلب كل العناصر من السلة
    const items = list() || [];
    console.log("getCartList:", items);
    // فلترة العناصر حسب النوع
    // إذا أردت تحويل أو إضافة خصائص افتراضية
    return items
      .filter((item) => lowerTypes.includes(item.Type?.toLowerCase()))
      .map((item) => ({
        ...item,
        name: lang == "ar" ? item.name : item.nameEn,
        originalPrice: item.originalPrice || item.price / 1.15,
        partNumber: item.productNo || "LEX-90919-01159",
        image: item.image || "https://appw.hassanjameelapp.com/assets/images/parts/PARTS_TOYOTA-AR-no-img.png",
        brandName: item.brandName || item.brand || "تويوتا",
        brandId: item.brand,
        warranty: item.warranty || "30 شهر",
        stock: item.stock ?? 10,
        quantity: item.quantity || 1,
        compatibility: ["لكزس ES 2020-2023", "لكزس IS 2021-2023"],
        isGenuine: true,
        isPremium: true,
        rating: 4.9,
        reviews: 89,
        features: ["إيريديوم متقدم", "استهلاك وقود أقل", "أداء محسن"],
      }));

    // const filteredItems = cartItems;
    // setItems(filteredItems);

    // return filteredItems;
  }
  useEffect(() => {
    // أول تحميل
    const itemsNow = getCartList();
    setItems(itemsNow);

    // عند أي تغيير في localStorage من أي مكان
    const onStorageChange = () => {
      const updatedItems = getCartList();
      setItems(updatedItems);
    };

    window.addEventListener("storage", onStorageChange);

    return () => {
      window.removeEventListener("storage", onStorageChange);
    };
  }, []);

  const updateCartListItems = async (item) => {
    const itemsNow = await getCartList();
    setItems(itemsNow);
  };
  // حسابات متقدمة
  useEffect(() => {
    if (items.length > 0) {
      handleCheckpartsCount();
    }
  }, [items]);
  const subtotal = items.reduce((total, item) => total + item.originalPrice * item.quantity, 0);
  const totalDiscount = items.reduce((total, item) => total + (item.originalPrice - item.price) * item.quantity, 0);

  const discount = 0;
  const shippingCost = 0;
  const tax = subtotal * 0.15;
  const total = subtotal + shippingCost + tax - discount;
  const totalItems = items.length;
  const savedAmount = items.reduce((total, item) => total + (item.originalPrice - item.price) * item.quantity, 0);

  const updateQuantity = async (itemId, Quantity) => {
    console.log("RupdateQuantity:", Quantity);
    if (Quantity === 0) {
      return;
      // removeItem(itemId);
    }
    setItems(items.map((item) => (item.id === itemId ? { ...item, quantity: item.quantity + Quantity } : item)));
    const isLogin = getData("isAuthenticated");
    if (isLogin) {
      const resultchangecartItem = await changecartItem(itemId, null, null, Quantity, null);
      // Account()
    } else {
      quantity(itemId, Quantity);
      // Account()
    }

    updateCartListItems();
  };

  const removeItem = async (itemId) => {
    console.log("Removing item with ID:", itemId);
    setItems(items.filter((item) => item.id !== itemId));
    await removecartItems(itemId, null, null, null, itemId);
    updateCartListItems();
  };

  const clearCart = async () => {
    //set items ids to remove
    const itemIds = items.map((item) => item.id);
    await removePulkcartItems(itemIds);
    updateCartListItems();
  };

  // مكون نصي باستخدام نظام الخطوط
  const CustomText = ({ children, size = 14, color = "black", className = "", ...props }) => (
    <Text
      style={{
        fontSize: textSizes[size] || size,
        color: colors[color] || color,
        lineHeight: `calc(${textSizes[size] || size} * 1.9)`,
      }}
      className={className}
      {...props}>
      {children}
    </Text>
  );
  const [PartQty, setPartQty] = useState([]);
  const getpartsCount = async () => {
    const cartItems = getCartList();

    if (!cartItems.length) return [];

    const productListIds = cartItems.map((a) => a.ProductID).join(",");

    const Body = {
      productListIds: productListIds,
    };

    try {
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/site_FeatchPartQty`, Body);

      console.log("site_FeatchPartQty", response.data);

      setPartQty(response.data);

      return response.data; // ✅ رجّع البيانات الفعلية
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const handleCheckpartsCount = async () => {
    const listError = [];
    const isLogin = getData("isAuthenticated");

    if (!isLogin) {
      thisConfirmContext.onShowRegistrationPup(true);
      return [];
    }

    const cartItems = getCartList();
    const stockList = await getpartsCount();

    cartItems.forEach((item) => {
      // ✅ نجمع الكمية من كل الفروع
      const totalQty = stockList.filter((s) => s.ProductID === item.ProductID).reduce((sum, s) => sum + Number(s.TotalQty), 0);

      // ✅ نجيب كل الفروع الخاصة بالمنتج
      const branches = stockList.filter((s) => s.ProductID === item.ProductID);
      // ✅ نجيب أكبر كمية موجودة في فرع واحد
      const maxQty = branches.length > 0 ? Math.max(...branches.map((b) => Number(b.TotalQty))) : 0;

      if (maxQty < item.quantity) {
        listError.push(item.id);
      }
    });

    setPartErrors(listError);

    if (listError.length > 0) {
      message.error({
        content: (
          <div
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}>
            الكمية المطلوبة غير متوفرة في جميع الفروع
          </div>
        ),
        duration: 3,
      });
    }

    return listError;
  };

  const handleCheckout = async () => {
    const isLogin = getData("isAuthenticated");

    if (!isLogin) {
      history.push({
        pathname: location.pathname,
        search: "?redirect=/parts/checkout",
      });

      thisConfirmContext.onShowRegistrationPup(true);
      return;
    }

    // 🔴 تحقق من المخزون مرة أخرى قبل الانتقال
    const errors = await handleCheckpartsCount();

    if (errors.length > 0) {
      message.error({
        content: (
          <div
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}>
            لا يمكن إكمال الطلب، توجد منتجات غير متوفرة
          </div>
        ),
        duration: 3,
      });
      return; // ⛔ منع الانتقال
    }

    // ✅ الانتقال فقط إذا كل شيء صحيح
    history.push({
      pathname: `/parts/checkout`,
    });
  };
  const CartItemCard = ({ item }) => (
    <Card
      className="premium-cart-item"
      style={{
        marginBottom: 20,
        borderRadius: 16,
        border: "none",
        background: colors.white,
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        overflow: "hidden",
        position: "relative",
        padding: 0,
      }}
      styles={{
        body: {
          padding: 0,
        },
      }}>
      {/* شريط الحالة - نص أبيض على خلفية ملونة */}
      <div
        style={{
          background: colors.primaryGradientOpacity,
          padding: "8px 20px",
          color: colors.white,
          fontSize: textSizes[11],
          fontWeight: "600",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        {/* <span className="text-18 text-white"> {trans("cartFile:warranty")} </span> */}
        {/* {item.isPremium && <span className="text-white text-18"> {trans("cartFile:featuredProduct")} </span>} */}
        {/* {item.isPerformance && <span className="text-white text-18"> {trans("cartFile:featuredProduct")} </span>} */}
      </div>

      <div style={{ padding: 15 }}>
        <Row gutter={20} align="middle">
          {/* الصورة */}
          <Col xs={24} sm={6} md={4}>
            <div style={{ position: "relative", textAlign: "center" }} className="bg-secondary border-radius">
              <Image
                width={100}
                height={100}
                src={item.image}
                style={{
                  borderRadius: 12,
                  objectFit: "cover",
                  border: `2px solid ${colors.grayLight}`,
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
                preview={true}
                fallback="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjRjBGMEYwIi8+CjxwYXRoIGQ9Ik01MCAzMEM1My4zMTM3IDMwIDU2IDMyLjY4NjMgNTYgMzZDNjYgMzYgNTYgNDQgNTYgNDRDNjYgNDQgNTYgNTIgNTYgNTJDNjYgNTIgNTYgNjAgNTYgNjBDNTYgNjMuMzEzNyA1My4zMTM3IDY2IDUwIDY2QzQ2LjY4NjMgNjYgNDQgNjMuMzEzNyA0NCA2MEM0NCA1MiAzNCA1MiAzNCA1MkM0NCA1MiAzNCA0NCAzNCA0NEM0NCA0NCAzNCAzNiAzNCAzNkM0NCAzNiAzNCAyOCAzNCAyOEMzNCAyNC42ODYzIDM2LjY4NjMgMjIgNDAgMjJDNTAgMjIgNDAgMzAgNDAgMzBDNDAgMjYuNjg2MyA0Mi42ODYzIDI0IDQ2IDI0QzQ5LjMxMzcgMjQgNTIgMjYuNjg2MyA1MiAzMEM1MiAzMCA2MiAyMiA3MiAyMkM3NS4zMTM3IDIyIDc4IDI0LjY4NjMgNzggMjhDNzggMzYgNjggMzYgNjggMzZDNzggMzYgNjggNDQgNjggNDRDNzggNDQgNjggNTIgNjggNTJDNzggNTIgNjggNjAgNjggNjBDNjggNjMuMzEzNyA2NS4zMTM3IDY2IDYyIDY2QzU4LjY4NjMgNjYgNTYgNjMuMzEzNyA1NiA2MEM1NiA1MiA0NiA1MiA0NiA1MkM1NiA1MiA0NiA0NCA0NiA0NEM1NiA0NCA0NiAzNiA0NiAzNkM1NiAzNiA0NiAyOCA0NiAyOEM0NiAyNC42ODYzIDQ4LjY4NjMgMjIgNTIgMjJDNjIgMjIgNTIgMzAgNTIgMzBaIiBmaWxsPSIjQ0VDRUNFIi8+Cjwvc3ZnPgo="
              />
              <div
                style={{
                  position: "absolute",
                  top: -8,
                  right: -8,
                  background: item.brandId == 1 ? "#000000ff" : "#d62828",
                  color: colors.white,
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: textSizes[12],
                  fontWeight: "bold",
                  boxShadow: "0 2px 8px rgba(59, 193, 44, 0.4)",
                }}>
                {item.quantity}
              </div>
            </div>
          </Col>

          {/* المعلومات */}
          <Col xs={24} sm={12} md={14}>
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div style={{ flex: 1 }}>
                  <Space style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    <CustomText
                      size={16}
                      color="black"
                      className="text-line-clamp-2"
                      style={{
                        lineHeight: 1.4,
                        display: "block",
                        marginBottom: 4,
                        fontWeight: "600",
                      }}>
                      {item.name}
                    </CustomText>
                    <Tooltip title="حفظ للمفضلة">
                      <Button type="text" icon={<HeartOutlined style={{ fontSize: "10px !important", width: "3rem" }} />} size="small" style={{ color: colors.gray }} />
                    </Tooltip>
                    <Tooltip title="مشاركة">
                      <Button type="text" icon={<ShareAltOutlined style={{ fontSize: "10px !important", width: "3rem" }} />} size="small" style={{ color: colors.gray }} />
                    </Tooltip>
                  </Space>

                  <CustomText size={12} color="gray">
                    {trans("cartFile:partNumber")} : {item.partNumber}
                  </CustomText>
                </div>
              </div>

              {/* التصنيف والعلامات */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                <Tag
                  style={{
                    background: item.brandId == 1 ? "#000000ff" : "#d62828",
                    color: "#ffffffff",
                    border: "none",
                    borderRadius: 12,
                    fontSize: textSizes[13],
                    fontWeight: "600",
                    height: "auto",
                    padding: "2px 8px",
                    lineHeight: 1.4,
                  }}>
                  {item.brandName}
                </Tag>
                {/* <Tag style={{ 
                  background: colors.info + '15', 
                  color: colors.info,
                  border: 'none',
                  borderRadius: 12,
                  fontSize: textSizes[11],
                  height: 'auto',
                  padding: '2px 8px',
                  lineHeight: 1.4
                }}>
                  {item.category}
                </Tag>
                {item.isGenuine && (
                  <Tag style={{ 
                    background: colors.success + '15', 
                    color: colors.success,
                    border: 'none',
                    borderRadius: 12,
                    fontSize: textSizes[11],
                    fontWeight: '600',
                    height: 'auto',
                    padding: '2px 8px',
                    lineHeight: 1.4
                  }}>
                    🏆 رسمي
                  </Tag>
                )}
                <div style={{ 
                  background: colors.warning + '15', 
                  color: colors.warning,
                  padding: '2px 8px',
                  borderRadius: 12,
                  fontSize: textSizes[10],
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  height: 'auto',
                  lineHeight: 1.4
                }}>
                  <span>⭐</span>
                  <span>{item.rating}</span>
                  <span>({item.reviews})</span>
                </div> */}
              </div>

              {/* الميزات */}
              {/* <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {item.features.slice(0, 2).map((feature, index) => (
                  <CustomText 
                    key={index}
                    size={11}
                    color="primary"
                    style={{ 
                      background: colors.primary + '10',
                      padding: '2px 8px',
                      borderRadius: 10,
                      border: `1px solid ${colors.primary}20`,
                      lineHeight: 1.4
                    }}
                  >
                    {feature}
                  </CustomText>
                ))}
              </div> */}

              {/* التوافق */}
              {/* <CustomText size={12} color="gray">
                                🚗 متوافق مع: {item.compatibility.join('، ')}
                            </CustomText> */}

              {/* السعر */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                <CustomText
                  size={18}
                  color="primary"
                  style={{
                    display: "block",
                    fontWeight: "600",
                  }}>
                  <Price price={item.price} />
                </CustomText>
                {item.originalPrice > item.price && (
                  <CustomText
                    size={12}
                    color="gray"
                    style={{
                      display: "block",
                      textDecoration: "line-through",
                    }}>
                    <Price price={item.originalPrice} />
                  </CustomText>
                )}
                {/* <div style={{
                                    background: colors.success + '15',
                                    color: colors.success,
                                    padding: '2px 8px',
                                    borderRadius: 8,
                                    fontSize: textSizes[10],
                                    marginTop: 4,
                                    fontWeight: '600',
                                    lineHeight: 1.4
                                }}>
                                    وفر {((item.originalPrice - item.price) / item.originalPrice * 100).toFixed(0)}%
                                </div> */}
              </div>
              {partErrors.includes(item.id) && (
                <div
                  style={{
                    marginTop: 10,
                    padding: "8px 12px",
                    background: "#fff1f0",
                    border: "1px solid #ffa39e",
                    borderRadius: 8,
                    color: "#cf1322",
                    fontSize: "13px",
                    fontWeight: "500",
                  }}>
                  ⚠ الكمية المطلوبة غير متوفرة في المخزون
                </div>
              )}
            </Space>
          </Col>

          {/* السعر والتحكم */}
          <Col xs={24} sm={6} md={6}>
            <Space direction="vertical" style={{ width: "100%" }} size="middle">
              {/* الإجراءات */}
              <Space direction="vertical" style={{ float: "left" }} size="small">
                <div style={{ display: "flex", gap: 8 }}>
                  <Button
                    type="link"
                    danger
                    size="small"
                    block
                    icon={<DeleteOutlined style={{ fontSize: "10px !important", width: "3rem" }} />}
                    onClick={() => removeItem(item.id)}
                    style={{
                      fontSize: textSizes[12],
                      alignItems: "end",
                      justifyContent: "end",
                    }}></Button>
                </div>
              </Space>

              {/* التحكم بالكمية */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}>
                <Button
                  type="text"
                  icon={<MinusOutlined style={{ fontSize: "10px !important", width: "3rem" }} />}
                  size="small"
                  onClick={() => updateQuantity(item.id, -1)}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    border: `1px solid ${colors.grayLight}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
                <InputNumber
                  min={1}
                  max={item.stock}
                  value={item.quantity}
                  onChange={(value) => {
                    const delta = Number(value) - Number(item.quantity);
                    updateQuantity(item.id, delta);
                  }}
                  controls={false}
                  style={{
                    width: 60,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: textSizes[17],
                  }}
                />
                <Button
                  type="text"
                  icon={<PlusOutlined style={{ fontSize: "10px !important", width: "3rem" }} />}
                  size="small"
                  onClick={() => updateQuantity(item.id, +1)}
                  disabled={item.quantity >= item.stock}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    border: `1px solid ${colors.grayLight}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
              </div>

              <CustomText
                size={16}
                color="primary"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  fontWeight: "600",
                }}>
                {<Price className="text-primary" price={(item.price * item.quantity).toFixed(2)} />}
              </CustomText>
            </Space>
          </Col>
        </Row>
      </div>
    </Card>
  );

  const PremiumCartSummary = () => (
    <Card
      className="premium-summary"
      style={{
        borderRadius: 20,
        border: "none",
        background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.grayLighter} 100%)`,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        position: "sticky",
        top: 20,
        overflow: "hidden",
      }}>
      {/* خلفية زخرفية */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: 120,
          height: 120,
          background: colors.primaryGradient,
          borderRadius: "0 0 0 100%",
          opacity: 0.1,
        }}></div>

      <div style={{ position: "relative", zIndex: 1 }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div
            style={{
              background: colors.primaryGradient,
              width: 60,
              height: 60,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 12px",
              boxShadow: "0 4px 12px rgba(0, 179, 98, 0.3)",
            }}>
            <ShoppingCartOutlined style={{ fontSize: textSizes[24], color: colors.white, width: "3rem" }} />
          </div>
          <CustomText size={20} color="secondary" style={{ fontWeight: "600", display: "block", marginBottom: 4 }}>
            {trans("new:order_details")}
          </CustomText>
          <CustomText size={14} color="gray">
            {totalItems} {trans("cartFile:productInCart")}
          </CustomText>
        </div>

        <Space direction="vertical" style={{ width: "100%" }} size="large">
          {/* تقدم الشحن المجاني */}
          {/* {subtotal < 500 && (
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                                <CustomText size={12} color="gray"> {trans("cartFile:freeShipping")} </CustomText>
                                <CustomText size={12} color="gray">{<Price price={(500 - subtotal)} />} {trans("cartFile:remaining")} </CustomText>
                            </div>
                            <Progress
                                percent={(subtotal / 500) * 100}
                                size="small"
                                strokeColor={colors.primary}
                                showInfo={false}
                            />
                        </div>
                    )} */}

          {/* التفاصيل المالية */}
          <Space direction="vertical" style={{ width: "100%" }} size="small">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 0",
                borderBottom: `1px solid ${colors.grayLight}`,
              }}>
              <CustomText size={14} color="grayDark" style={{ display: "flex", alignItems: "center", fontSize: "1.5rem" }}>
                {" "}
                {trans("cartFile:subtotal")}
              </CustomText>
              <CustomText size={14} color="black" style={{ fontWeight: "600" }}>
                {<Price price={subtotal.toFixed(2)} />}{" "}
              </CustomText>
            </div>

            {totalDiscount > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "12px 0",
                  borderBottom: `1px solid ${colors.grayLight}`,
                }}>
                <CustomText size={14} color="success" style={{ display: "flex", alignItems: "center" }}>
                  <GiftOutlined style={{ marginLeft: 4, fontSize: "10px !important", width: "3rem" }} />
                  التوفير
                </CustomText>
                <CustomText size={14} color="success" style={{ fontWeight: "600", display: "flex" }}>
                  -{<Price price={totalDiscount.toFixed(2)} />}{" "}
                </CustomText>
              </div>
            )}
            {tax > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "12px 0",
                  borderBottom: `1px solid ${colors.grayLight}`,
                }}>
                <CustomText size={10} color="grayDark" style={{ display: "flex", alignItems: "center", fontSize: "1.5rem" }}>
                  {trans("new:tax_15")}
                </CustomText>
                <CustomText size={14} color="black" style={{ fontWeight: "600", display: "flex" }}>
                  {<Price price={tax.toFixed(2)} />}
                </CustomText>
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 0",
              }}>
              <CustomText size={16} color="black" style={{ fontWeight: "600" }}>
                {" "}
                {trans("new:total")}
              </CustomText>
              <CustomText size={20} color="primary" style={{ fontWeight: "600" }}>
                <Price price={total.toFixed(2)} />
              </CustomText>
            </div>
          </Space>

          {/* أزرار الإجراءات */}
          <Space direction="vertical" style={{ width: "100%" }} size="middle">
            <Button
              type="primary"
              size="large"
              block
              classNames="text-white"
              style={{
                height: 50,
                borderRadius: 12,
                fontSize: textSizes[20],
                fontWeight: "700",
                background: colors.primaryGradient,
                color: colors.white,
                border: "none",
                boxShadow: "0 4px 15px rgba(0, 179, 98, 0.3)",
                opacity: partErrors.length > 0 ? 0.6 : 1,
                cursor: partErrors.length > 0 ? "not-allowed" : "pointer",
              }}
              disabled={partErrors.length > 0}
              icon={<RocketOutlined style={{ fontSize: "10px !important", width: "3rem", color: "#FFFFFF" }} />}
              onClick={handleCheckout}>
              {trans("new:complete_order")}
            </Button>

            <Button
              size="large"
              block
              style={{
                height: 45,
                borderRadius: 12,
                fontSize: textSizes[18],
                border: `2px solid ${colors.grayLight}`,
                color: colors.grayDark,
                background: colors.white,
                fontWeight: "600",
              }}
              icon={<ArrowLeftOutlined style={{ fontSize: "10px !important", width: "3rem" }} />}
              onClick={() => {
                if (location.pathname) history.push("/");
              }}>
              {trans("cartFile:Continue_browsing")}
            </Button>
          </Space>

          {/* ميزات إضافية */}
          <div
            style={{
              background: colors.grayLighter,
              borderRadius: 12,
              padding: 16,
              textAlign: "center",
            }}>
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
              <SafetyCertificateOutlined style={{ fontSize: textSizes[20], color: colors.primary }} />
              <CustomText size={13} color="black" style={{ fontWeight: "600" }}>
                {trans("cartFile:securePurchase")}
              </CustomText>
              <CustomText size={11} color="gray">
                {trans("cartFile:warrantyAndSupport")}
              </CustomText>
            </Space>
          </div>
        </Space>
      </div>
    </Card>
  );

  const EmptyCart = () => (
    <Card
      style={{
        borderRadius: 20,
        border: "none",
        background: colors.white,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 60,
      }}>
      <Empty
        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
        imageStyle={{ height: 120 }}
        description={
          <Space direction="vertical" size="small">
            <CustomText size={18} color="black" style={{ fontWeight: "600" }}>
              {trans("cartFile:emptyCart")}
            </CustomText>
            <CustomText size={14} color="gray">
              {trans("cartFile:noProductsInCart")}
            </CustomText>
          </Space>
        }>
        <Button
          type="primary"
          size="large"
          style={{
            background: colors.primaryGradient,
            border: "none",
            borderRadius: 12,
            height: 50,
            fontSize: textSizes[16],
            fontWeight: "600",
            padding: "0 30px",
          }}
          icon={<ArrowLeftOutlined />}>
          {trans("cartFile:backToStore")}
        </Button>
      </Empty>
    </Card>
  );

  return (
    <div
      style={{
        background: `linear-gradient(135deg, ${colors.grayLighter} 0%, ${colors.white} 50%, ${colors.grayLighter} 100%)`,
        minHeight: "100vh",
        padding: "20px 0",
      }}>
      <div
        style={{
          width: "100%",
          maxWidth: "clamp(1400px, 92vw, 2200px)",
          margin: "0 auto",
          padding: "0 24px",
        }}>
        <Breadcrumb
          className={" "}
          links={[
            {
              name: trans("eparts:EpartTitel"),
              to: "/parts",
            },
            {
              className: "text-primary",
              name: trans("cartFile:sparePartsCart"),
              to: `/parts/cart`,
            },
          ]}
        />

        {/* الهيدر المميز */}
        <div
          style={{
            background: colors.white,
            padding: "30px 40px",
            borderRadius: 24,
            marginBottom: 30,
            border: `1px solid ${colors.grayLight}`,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}>
          {/* خلفية زخرفية */}
          <div
            style={{
              position: "absolute",
              top: -50,
              right: -50,
              width: 200,
              height: 200,
              background: colors.primaryGradient,
              borderRadius: "50%",
              opacity: 0.05,
            }}></div>
          <div
            style={{
              position: "absolute",
              bottom: -30,
              left: -30,
              width: 150,
              height: 150,
              background: colors.accent,
              borderRadius: "50%",
              opacity: 0.05,
            }}></div>

          <CustomText
            size={40}
            style={{
              display: "block",
              marginBottom: 8,
              fontWeight: "800",
              background: colors.primaryGradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}>
            🛒 {trans("cartFile:sparePartsCart")}
          </CustomText>
          <CustomText
            size={16}
            color="gray"
            style={{
              display: "block",
              maxWidth: 400,
              margin: "0 auto",
            }}>
            {trans("cartFile:reviewOrder")}
          </CustomText>
        </div>

        {items?.length > 0 ? (
          <Row gutter={[30, 30]}>
            <Col xs={24} sm={24} md={24} xl={16}>
              <Card
                style={{
                  borderRadius: 20,
                  border: "none",
                  background: colors.white,
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 30,
                    paddingBottom: 20,
                    borderBottom: `2px solid ${colors.grayLight}`,
                  }}>
                  <Space>
                    <div
                      style={{
                        background: colors.primaryGradient,
                        width: 40,
                        height: 40,
                        borderRadius: 12,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(0, 179, 98, 0.3)",
                      }}>
                      <ShoppingCartOutlined style={{ fontSize: textSizes[20], color: colors.white, width: "3rem" }} />
                    </div>
                    <div>
                      <CustomText size={24} color="black" style={{ fontWeight: "600", display: "block" }}>
                        {trans("cartFile:sparePartsCart")}
                      </CustomText>
                      <CustomText size={14} color="gray">
                        {totalItems} {trans("cartFile:productInCart")}
                      </CustomText>
                    </div>
                  </Space>

                  <Button
                    type="primary"
                    // danger
                    size="large"
                    icon={<DeleteOutlined style={{ fontSize: "10px !important", width: "3rem" }} />}
                    onClick={clearCart}
                    style={{
                      border: `2px solid ${colors.grayLight}`,
                      color: colors.grayDark,
                      background: colors.white,

                      //   background: colors.danger,
                      //   borderColor: colors.danger,
                      borderRadius: 12,
                      fontWeight: "600",
                      fontSize: textSizes[15],
                    }}>
                    {trans("cartFile:clearCart")}
                  </Button>
                </div>

                {items.map((item) => (
                  <CartItemCard key={item.id} item={item} />
                ))}
              </Card>
            </Col>

            <Col xs={24} sm={24} md={24} xl={8}>
              <PremiumCartSummary />
            </Col>
          </Row>
        ) : (
          <EmptyCart />
        )}
      </div>
    </div>
  );
};

export default PremiumCartPage;
